var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"label":_vm.getVisitedCheckboxText(_vm.poiAlreadyVisited),"value":_vm.poiAlreadyVisited},model:{value:(_vm.poiAlreadyVisited),callback:function ($$v) {_vm.poiAlreadyVisited=$$v},expression:"poiAlreadyVisited"}})}
var staticRenderFns = []

export { render, staticRenderFns }